import { Field } from "formik";
import React, { useState } from "react";
import * as yup from "yup";
import FormikForm from "../../../../components/crud/FormikForm";
import TextArea from "../../../../components/form-fields/TextArea";
import CurrencyInput from "../../../../components/form-fields/CurrencyInput";
import Select from "../../../../components/form-fields/Select";
import TextInput from "../../../../components/form-fields/TextInput";
import { Button } from 'react-bootstrap';
import { useTranslation } from "react-i18next";

export default function Expenses(props) {
  const [configData, setConfigData] = useState(null);
  const [digerTextboxVisibility, setDigerTextboxVisibility] = useState(false);
  const [endPointUrl, setEndPointUrl] = useState('yonlendirilecek-talep/masraf-ekle');
  const [initialValues, setInitialValues] = useState({});
  const [isUpdating, setIsUpdating] = useState(true);
  const [id, setId] = useState(-1);
  const { t } = useTranslation();
  const validationSchema = yup.object({});

  const arrangeBeforePersist = (values) => {

    let payload = {
      id: id,
      gorevliDisAvukat: values.gorevliDisAvukat,
      disAvukatText: values.disAvukatText,
      ucret: values.ucret,
      makbuzAciklama: values.makbuzAciklama,
    };

    if (payload.id == -1) {
      delete payload.id;
      payload.talepId = props.selectedRow.id;
    }

    return payload;
  };


  const adaptDataForUpdate = (data) => {

    if (data.tableData.length) {
      setId(data.tableData[0].id);
      
      let adaptedData = {
          id: data.tableData[0].id,
          gorevliDisAvukat: data.tableData[0].gorevliDisAvukat,
          ucret: data.tableData[0].ucret,
          makbuzAciklama: data.tableData[0].makbuzAciklama,
          disAvukatText: data.tableData[0].disAvukatText
      };

      setInitialValues(adaptedData);
      
      if(adaptedData.disAvukatText != null) {
        setDigerTextboxVisibility(true);
      }
    }

    setIsUpdating(data.tableData.length > 0);
  };

  return (
    <div className="row">
      <div className="col-md-12 col-xl-12 col-xxl-12">

        <FormikForm
          keyField={"masrafForm"}
          isUpdating={isUpdating}
          entityId={props.selectedRow && props.selectedRow.id}
          entityFetchId="id"
          endPointUrl="yonlendirilecek-talep/masraf-ekle"
          configParameterName="talepTurId"
          configParameterValue={
            props.selectedRow && props.selectedRow.talepTur.id
          }
          configReqType={"POST"}
          fetchPointUrl="yonlendirilecek-talep/masraf-listele"
          editPointUrl="yonlendirilecek-talep/masraf-update"
          configPointUrl="yonlendirilecek-talep/config"
          arrangeBeforePersist={arrangeBeforePersist}
          adaptDataForUpdate={adaptDataForUpdate}
          setConfigData={(data) => {
            setConfigData(data);
          }}
          initialValues={initialValues}
          validationSchema={validationSchema}
          refreshList={(res) => {
            setInitialValues(res.body);
            setIsUpdating(true);
            props.setRefreshList(!props.refreshList)
          }}
          okButtonText={t("tabs.guncelle")}
        >
          <div className="form-group col-md-6">
            <Field
              name="gorevliDisAvukat"
              buttonLabel = {
                <>
                  <Button
                    className="btn-xs ml-3 px-2 py-1 rounded-circle"
                    variant="primary"
                    onClick={() => setDigerTextboxVisibility(!digerTextboxVisibility)}
                  >
                      <i className={ "fa fa-" + (digerTextboxVisibility ? "minus" : "plus") }/>
                  </Button>
                </>
              }
              label={t("demandUpdate.disAvukatAdSoyAd")}
              colNumber="-6"
              component={Select}
              placeholder={t("formFields.allPlaceHolder")}
              options={configData && configData.disAvukatlar}
            />
            {digerTextboxVisibility && (
              <Field
                name="disAvukatText"
                label={t("demandUpdate.digerDisAvukatAdSoyAd")}
                colNumber="-6 hide-label"
                component={TextInput}
              />
            )}
          </div>
          <Field
              name="ucret"
              label={t("documentTypes.ücret")}
              colNumber="6"
              component={CurrencyInput}
              isSignVisible={true}
            />
          <Field
            name="makbuzAciklama"
            label={t("demandUpdate.makbuzAciklamasi")}
            colNumber="12"
            component={TextArea}
            />
        </FormikForm>
      </div>
    </div>
  );
}
